/* ============================================================================
   Gaucheria — página de produto
   ----------------------------------------------------------------------------
   Faz três coisas, todas como melhoria progressiva:

   1. Troca o seletor de variante. Sem este arquivo, o <select name="id"> nativo
      continua ali e o POST do Shopify funciona. Aqui os botões de tamanho passam
      a mandar: o input escondido é habilitado e o select é desabilitado, para
      nunca haver dois campos "id" concorrendo no mesmo formulário.

   2. Troca a foto principal ao clicar numa miniatura.

   3. Abre o guia de medidas em <dialog> nativo, com showModal(): traz focus trap
      e fechar com Escape de graça. Os componentes .jsx do design system não têm
      focus trap. Essa falha não foi portada.

   4. Deixa visível no guia só a tabela da modelagem escolhida.
   ============================================================================ */

(function ()
{
  'use strict';

  var secao = document.querySelector('[data-secao-produto]');
  if (!secao) { return; }

  var variantes = [];
  var fonte = secao.querySelector('[data-variantes-produto]');

  if (fonte)
  {
    try
    {
      variantes = JSON.parse(fonte.textContent) || [];
    }
    catch (e)
    {
      variantes = [];
    }
  }

  var campoId = secao.querySelector('[data-id-variante]');
  var selectFallback = secao.querySelector('[data-select-variante]');
  var botaoAdicionar = secao.querySelector('[data-botao-adicionar]');
  var rotuloAdicionar = secao.querySelector('[data-rotulo-adicionar]');
  var fotoPrincipal = secao.querySelector('[data-foto-principal]');

  function textoDe(chave, padrao)
  {
    var raiz = document.querySelector('[data-textos-sacola]');
    if (raiz && raiz.getAttribute('data-' + chave))
    {
      return raiz.getAttribute('data-' + chave);
    }
    return padrao;
  }

  /* ------------------------------------------------------------------------
     Inverte quem manda: o input escondido passa a valer, o select sai de cena.
     ------------------------------------------------------------------------ */
  function assumirControle()
  {
    if (campoId) { campoId.disabled = false; }
    if (selectFallback) { selectFallback.disabled = true; }
  }

  /* ------------------------------------------------------------------------
     Seletor de opções
     ------------------------------------------------------------------------ */
  function valoresSelecionados()
  {
    var grupos = secao.querySelectorAll('.seletor-opcoes__grupo');
    var escolhidos = [];
    var i;

    for (i = 0; i < grupos.length; i = i + 1)
    {
      var marcado = grupos[i].querySelector('input:checked');
      escolhidos.push(marcado ? marcado.value : null);
    }

    return escolhidos;
  }

  function acharVariante(escolhidos)
  {
    var i;
    var j;

    for (i = 0; i < variantes.length; i = i + 1)
    {
      var bate = true;

      for (j = 0; j < escolhidos.length; j = j + 1)
      {
        if (escolhidos[j] !== null && variantes[i].options[j] !== escolhidos[j])
        {
          bate = false;
          break;
        }
      }

      if (bate) { return variantes[i]; }
    }

    return null;
  }

  /* ------------------------------------------------------------------------
     Disponibilidade das opções

     Um valor de opção tem TRÊS estados, e confundir dois deles foi o defeito
     encontrado em 06/09/2026 na Camiseta Capincho de algodão peruano:

       à venda    -> normal
       esgotado   -> RISCADO, e continua na grade. Regra de marca: o cliente
                     precisa ver que a cor existe e acabou.
       não existe -> SAI da grade. Verde Musgo e 4G só existem na modelagem
                     masculina; oferecê-los com Feminino escolhido é anunciar
                     uma peça que a Reserva não fabrica. Riscar também estaria
                     errado — riscado promete que um dia volta.

     O Liquid pinta a grade UMA vez, olhando o produto inteiro ("existe alguma
     variante à venda com este valor?"), porque na primeira pintura o cliente
     ainda não escolheu nada. Daqui em diante quem manda é esta função.

     O cálculo é preso ao que já foi escolhido nas opções ANTERIORES à que
     está sendo pintada, e os grupos são percorridos em ordem: modelagem,
     depois cor, depois tamanho. É a ordem em que o cliente lê a grade, e faz
     a cascata resolver sozinha — ao trocar de modelagem, a cor se ajusta, e
     o tamanho se ajusta à cor nova.

     A grade da Reserva não é cheia e não vai ser: cada estampa chega com um
     conjunto diferente de cor e tamanho por modelagem.
     ------------------------------------------------------------------------ */
  function combina(variante, valores)
  {
    var i;

    for (i = 0; i < valores.length; i = i + 1)
    {
      if (valores[i] !== null && variante.options[i] !== valores[i]) { return false; }
    }

    return true;
  }

  function pintarValor(radio, rotulo, existe, vendavel)
  {
    radio.hidden = !existe;

    if (vendavel) { radio.removeAttribute('data-indisponivel'); }
    else { radio.setAttribute('data-indisponivel', 'true'); }

    if (!rotulo) { return; }

    rotulo.hidden = !existe;
    rotulo.classList.toggle('seletor-opcoes__valor--indisponivel', existe && !vendavel);

    /* O aviso só existe para leitor de tela, e tem de acompanhar o risco.
       Sem isto a grade fica certa no olho e mentindo no ouvido. */
    var aviso = rotulo.querySelector('[data-aviso-esgotado]');
    if (aviso) { aviso.hidden = vendavel || !existe; }
  }

  function atualizarOpcoes()
  {
    var grupos = secao.querySelectorAll('.seletor-opcoes__grupo');
    var escolhidos = valoresSelecionados();
    var g;

    for (g = 0; g < grupos.length; g = g + 1)
    {
      var radios = grupos[g].querySelectorAll('.seletor-opcoes__radio');
      var anteriores = escolhidos.slice(0, g);
      var primeiroVendavel = null;
      var primeiroExistente = null;
      var r;

      for (r = 0; r < radios.length; r = r + 1)
      {
        var candidato = anteriores.concat([radios[r].value]);
        var existe = false;
        var vendavel = false;
        var i;

        for (i = 0; i < variantes.length; i = i + 1)
        {
          if (!combina(variantes[i], candidato)) { continue; }

          existe = true;

          if (variantes[i].available) { vendavel = true; break; }
        }

        pintarValor(radios[r], grupos[g].querySelector('label[for="' + radios[r].id + '"]'), existe, vendavel);

        if (existe && !primeiroExistente) { primeiroExistente = radios[r]; }
        if (vendavel && !primeiroVendavel) { primeiroVendavel = radios[r]; }
      }

      /* Se o valor escolhido sumiu da grade — o caso do Verde Musgo quando o
         cliente troca para Feminino —, o formulário ficaria apontando para uma
         combinação inexistente. Cai no primeiro que dá para comprar; e se
         nenhum dá, no primeiro que ao menos existe, para o cliente ver a cor
         esgotada em vez de uma grade vazia. */
      var marcado = grupos[g].querySelector('input:checked');

      if (!marcado || marcado.hidden)
      {
        var substituto = primeiroVendavel || primeiroExistente;

        if (substituto)
        {
          substituto.checked = true;
          marcado = substituto;
        }
      }

      escolhidos[g] = marcado ? marcado.value : null;
    }

    return escolhidos;
  }

  /* ------------------------------------------------------------------------
     A foto grande só segue a variante quando o CLIENTE escolhe uma opção.

     Ao abrir a página, a grade já vem com modelagem, cor e tamanho marcados,
     porque o formulário precisa de uma variante para comprar. Trocar a foto
     nesse momento punha na tela a foto da Reserva daquela cor, e não a foto
     de destaque da Gaucheria, que é a primeira do produto e a que o Liquid
     imprime. Corrigido em 11/09/2026, a pedido do Gilnei.
     ------------------------------------------------------------------------ */
  function aplicarVariante(variante, trocarFoto)
  {
    if (!variante)
    {
      if (botaoAdicionar) { botaoAdicionar.disabled = true; }
      if (rotuloAdicionar) { rotuloAdicionar.textContent = textoDe('esgotado', 'Esgotado'); }
      return;
    }

    if (campoId) { campoId.value = variante.id; }

    if (botaoAdicionar) { botaoAdicionar.disabled = !variante.available; }

    if (rotuloAdicionar)
    {
      rotuloAdicionar.textContent = variante.available
        ? textoDe('adicionar', 'Adicionar à sacola')
        : textoDe('esgotado', 'Esgotado');
    }

    if (trocarFoto && fotoPrincipal && variante.featured_image && variante.featured_image.src)
    {
      fotoPrincipal.src = variante.featured_image.src;
      fotoPrincipal.removeAttribute('srcset');
      if (variante.featured_image.alt) { fotoPrincipal.alt = variante.featured_image.alt; }
    }

    atualizarPreco(variante.id);

    var url = secao.getAttribute('data-url-produto');
    if (url && window.history && window.history.replaceState)
    {
      window.history.replaceState({}, '', url + '?variant=' + variante.id);
    }
  }

  /* ------------------------------------------------------------------------
     Preço: vem do servidor, para o formato de moeda continuar sendo o da loja.
     Nada de formatar dinheiro no navegador.
     ------------------------------------------------------------------------ */
  function atualizarPreco(idVariante)
  {
    var url = secao.getAttribute('data-url-produto');
    var idSecao = secao.getAttribute('data-id-secao');
    var alvo = secao.querySelector('.produto__coluna .preco');

    if (!url || !idSecao || !alvo) { return; }

    fetch(url + '?variant=' + idVariante + '&section_id=' + idSecao)
      .then(function (resposta) { return resposta.text(); })
      .then(function (html)
      {
        var casulo = document.createElement('div');
        casulo.innerHTML = html;

        var novo = casulo.querySelector('.produto__coluna .preco');
        if (novo) { alvo.innerHTML = novo.innerHTML; }
      })
      .catch(function () { /* preço antigo continua na tela; melhor que uma tela quebrada */ });
  }

  /* ------------------------------------------------------------------------
     Guia de medidas: a tabela segue a modelagem

     Camiseta com Feminino e Masculino chega com as duas tabelas no guia, e a
     baby look é 9 cm mais estreita que a regular no M. Mostrar as duas lado a
     lado deixa o cliente achar a errada. Aqui fica só a da modelagem marcada.

     O Liquid diz em `data-indice-estilo` qual opção é a modelagem, e cada
     tabela diz em `data-guia-estilo` a qual modelagem pertence. Tabela sem
     modelagem (moletom, body) vale para qualquer escolha.

     Com abas (duas tabelas ou mais), fica sempre UMA visível: a da modelagem
     escolhida, ou a primeira quando não há escolha, que é o caso da grade do
     lojista, que não usa os botões.

     Sem abas, sem modelagem escolhida ficam todas. Se nenhuma casar, também:
     guia vazio é pior.
     ------------------------------------------------------------------------ */
  function mostrarGuia(raiz, alvo)
  {
    var guias = raiz.querySelectorAll('[data-guia-estilo]');
    var abas = raiz.querySelectorAll('[role="tab"]');
    var i;

    for (i = 0; i < guias.length; i = i + 1)
    {
      guias[i].hidden = guias[i] !== alvo;
    }

    for (i = 0; i < abas.length; i = i + 1)
    {
      var ativa = abas[i].getAttribute('aria-controls') === alvo.id;

      abas[i].setAttribute('aria-selected', ativa ? 'true' : 'false');
      abas[i].tabIndex = ativa ? 0 : -1;
    }
  }

  function atualizarGuia(escolhidos)
  {
    var raiz = secao.querySelector('[data-guias-medidas]');
    if (!raiz) { return; }

    var indice = parseInt(raiz.getAttribute('data-indice-estilo'), 10);
    var escolhido = indice >= 0 && escolhidos[indice] ? escolhidos[indice].toLowerCase() : null;
    var guias = raiz.querySelectorAll('[data-guia-estilo]');
    var algumaVisivel = false;
    var i;

    if (raiz.querySelector('[role="tab"]') && guias.length)
    {
      var alvo = guias[0];

      for (i = 0; escolhido && i < guias.length; i = i + 1)
      {
        var estiloGuia = guias[i].getAttribute('data-guia-estilo');
        if (estiloGuia === '' || estiloGuia === escolhido) { alvo = guias[i]; break; }
      }

      mostrarGuia(raiz, alvo);
      return;
    }

    for (i = 0; i < guias.length; i = i + 1)
    {
      var estilo = guias[i].getAttribute('data-guia-estilo');
      var mostrar = !escolhido || estilo === '' || estilo === escolhido;

      guias[i].hidden = !mostrar;
      if (mostrar) { algumaVisivel = true; }
    }

    if (algumaVisivel) { return; }

    for (i = 0; i < guias.length; i = i + 1)
    {
      guias[i].hidden = false;
    }
  }

  /* ------------------------------------------------------------------------
     Abas do guia: padrão de abas do WAI-ARIA. Clique ou seta do teclado troca
     a tabela; Home e End vão para a primeira e a última. Só muda o que o
     cliente vê: o seletor de modelagem e a variante ficam como estão.
     ------------------------------------------------------------------------ */
  function ligarAbas()
  {
    var raiz = secao.querySelector('[data-guias-medidas]');
    if (!raiz) { return; }

    var abas = raiz.querySelectorAll('[role="tab"]');
    if (!abas.length) { return; }

    var i;

    for (i = 0; i < abas.length; i = i + 1)
    {
      var painel = document.getElementById(abas[i].getAttribute('aria-controls'));
      if (!painel) { continue; }

      painel.setAttribute('role', 'tabpanel');
      painel.setAttribute('aria-labelledby', abas[i].id);
    }

    function painelDa(aba)
    {
      return document.getElementById(aba.getAttribute('aria-controls'));
    }

    raiz.addEventListener('click', function (evento)
    {
      var aba = evento.target.closest ? evento.target.closest('[role="tab"]') : null;
      if (!aba || !painelDa(aba)) { return; }

      mostrarGuia(raiz, painelDa(aba));
    });

    raiz.addEventListener('keydown', function (evento)
    {
      var aba = evento.target.closest ? evento.target.closest('[role="tab"]') : null;
      if (!aba) { return; }

      var lista = Array.prototype.slice.call(abas);
      var atual = lista.indexOf(aba);
      var proxima = null;

      if (evento.key === 'ArrowRight') { proxima = lista[(atual + 1) % lista.length]; }
      else if (evento.key === 'ArrowLeft') { proxima = lista[(atual - 1 + lista.length) % lista.length]; }
      else if (evento.key === 'Home') { proxima = lista[0]; }
      else if (evento.key === 'End') { proxima = lista[lista.length - 1]; }

      if (!proxima || !painelDa(proxima)) { return; }

      evento.preventDefault();
      mostrarGuia(raiz, painelDa(proxima));
      proxima.focus();
    });
  }

  function ligarSeletor()
  {
    secao.addEventListener('change', function (evento)
    {
      var radio = evento.target.closest ? evento.target.closest('.seletor-opcoes__radio') : null;
      if (!radio) { return; }

      var escolhidos = atualizarOpcoes();
      atualizarGuia(escolhidos);
      aplicarVariante(acharVariante(escolhidos), true);
    });

    var iniciais = atualizarOpcoes();
    atualizarGuia(iniciais);
    aplicarVariante(acharVariante(iniciais), false);
  }

  /* ------------------------------------------------------------------------
     Galeria
     ------------------------------------------------------------------------ */
  function ligarGaleria()
  {
    var miniaturas = secao.querySelectorAll('[data-miniatura]');
    if (!miniaturas.length || !fotoPrincipal) { return; }

    secao.addEventListener('click', function (evento)
    {
      var botao = evento.target.closest ? evento.target.closest('[data-miniatura]') : null;
      if (!botao) { return; }

      var i;
      for (i = 0; i < miniaturas.length; i = i + 1)
      {
        miniaturas[i].classList.remove('produto__miniatura--ativa');
      }

      botao.classList.add('produto__miniatura--ativa');
      fotoPrincipal.src = botao.getAttribute('data-foto');
      fotoPrincipal.removeAttribute('srcset');
    });
  }

  /* ------------------------------------------------------------------------
     Guia de medidas
     ------------------------------------------------------------------------ */
  function ligarDialogo()
  {
    var dialogo = secao.querySelector('[data-dialogo-medidas]');
    var abrir = secao.querySelector('[data-abrir-medidas]');

    if (!dialogo || !abrir) { return; }

    if (typeof dialogo.showModal !== 'function')
    {
      abrir.hidden = true;
      return;
    }

    abrir.addEventListener('click', function ()
    {
      /* Reabrir sempre na modelagem escolhida, mesmo que o cliente tenha
         olhado outra aba da última vez. */
      atualizarGuia(valoresSelecionados());
      dialogo.showModal();
    });

    var fechar = dialogo.querySelectorAll('[data-fechar-dialogo]');
    var i;

    for (i = 0; i < fechar.length; i = i + 1)
    {
      fechar[i].addEventListener('click', function ()
      {
        dialogo.close();
      });
    }

    dialogo.addEventListener('click', function (evento)
    {
      if (evento.target === dialogo) { dialogo.close(); }
    });
  }

  function iniciar()
  {
    assumirControle();
    ligarAbas();
    ligarSeletor();
    ligarGaleria();
    ligarDialogo();
  }

  if (document.readyState === 'loading')
  {
    document.addEventListener('DOMContentLoaded', iniciar);
  }
  else
  {
    iniciar();
  }
}());
